import './index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'
import 'vue-sonner/style.css'
import GoogleSignInPlugin from 'vue3-google-signin'
import App from './App.vue'
import { router } from './router'
import { addIcons } from 'oh-vue-icons'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from './queryClient'
import {
  MdDragindicator,
  MdAddRound,
  LaTrashAlt,
  BiTextLeft,
  OiRss,
  BiLink45Deg,
  LaPodcastSolid,
  BiPlayBtn,
  BiFileEarmarkCode,
  BiStars,
  BiX,
  MdContentcopy,
  MdExittoapp,
  MdLogin,
  MdLogout,
  MdRotateleftRound,
  BiUpload,
  BiSoundwave,
  IoSwapHorizontal,
  IoReload,
  BiCloudUpload,
  BiSearch,
  BiFileEarmark,
  BiChevronDown,
  MdSpacedashboardOutlined,
  LaUserSolid,
  IoCodeWorkingOutline,
  OiOrganization,
  FaListUl,
  FaListOl,
  RiDoubleQuotesL,
  FaBold,
  FaItalic,
  FaStrikethrough,
  FaHighlighter,
  FaFont,
  FaUndoAlt,
  FaRedoAlt,
  MdKeyboardarrowdownRound,
  FaEdit,
  RiHistoryFill,
  FaUser,
  MdVpnkey,
  IoAdd,
  IoInformation,
  MdEmail,
  GiToken
} from 'oh-vue-icons/icons'

import 'setimmediate'

import { i18n } from './components/lang/langHandler'

if (import.meta.env.DEV && import.meta.env.VITE_VUE_TRACER_ENABLED !== 'false') {
  void import('./devtools/vueTracerBridge')
}

// Force favicon reload to fix dev mode issues
const updateFavicon = () => {
  const links = document.querySelectorAll<HTMLLinkElement>("link[rel*='icon']")
  links.forEach((link: HTMLLinkElement) => {
    const url = link.href
    link.href = url + '?v=' + new Date().getTime()
  })
}
document.addEventListener('DOMContentLoaded', updateFavicon) // TODO: investigate requirednesssss

addIcons(
  MdDragindicator,
  MdAddRound,
  LaTrashAlt,
  BiTextLeft,
  OiRss,
  BiLink45Deg,
  LaPodcastSolid,
  BiPlayBtn,
  BiFileEarmarkCode,
  BiStars,
  BiX,
  MdContentcopy,
  MdExittoapp,
  MdLogin,
  MdLogout,
  MdRotateleftRound,
  BiUpload,
  BiSoundwave,
  IoSwapHorizontal,
  IoReload,
  BiCloudUpload,
  BiSearch,
  BiFileEarmark,
  BiChevronDown,
  MdSpacedashboardOutlined,
  LaUserSolid,
  IoCodeWorkingOutline,
  OiOrganization,
  FaListUl,
  FaListOl,
  RiDoubleQuotesL,
  FaBold,
  FaItalic,
  FaStrikethrough,
  FaHighlighter,
  FaFont,
  FaUndoAlt,
  FaRedoAlt,
  MdKeyboardarrowdownRound,
  FaEdit,
  RiHistoryFill,
  FaUser,
  MdVpnkey,
  IoAdd,
  IoInformation,
  MdEmail,
  GiToken
)

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ToastPlugin)
app.use(VueQueryPlugin, { queryClient })
app.use(GoogleSignInPlugin, {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID
})
app.use(i18n)
app.mount('#app')
